import queryString from "query-string"
import { IResPag } from "utils/types"
import { IPaginationReq } from "utils/interfaces"
import { TAGS, api } from "../../api"
import { balanceEndpoints } from "../balanceAPI/balance.api"
import {
  IRecipeCraftInfo,
  IRecipeCraftResponse,
  IRecipeInstance,
  ISellRecipeRes
} from "./types"

const basePath = "/recipes"

export const recipeApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.RECIPES, TAGS.APPARELS]
})

export const recipeEndpoints = recipeApi.injectEndpoints({
  endpoints: (builder) => ({
    getRecipes: builder.query<IResPag<IRecipeInstance>, IPaginationReq>({
      query: ({ page, limit }) => {
        const query = queryString.stringify(
          {
            page,
            limit
          },
          { skipEmptyString: true, skipNull: true }
        )

        return {
          url: `${basePath}/recipes-instances?${query}`,
          method: "GET"
        }
      },
      providesTags: (_, __, { page, limit }) => [
        { type: TAGS.RECIPES, id: `LIST` },
        { type: TAGS.RECIPES, id: `LIST:page:${page}:limit:${limit}` }
      ]
    }),
    sellRecipe: builder.mutation<ISellRecipeRes, string>({
      query: (recipeId) => ({
        url: `${basePath}/sell/${recipeId}`,
        method: "POST"
      }),
      invalidatesTags: [{ type: TAGS.RECIPES, id: "LIST" }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled

          dispatch(
            balanceEndpoints.util.updateQueryData(
              "getBalance",
              undefined,
              (draft) => {
                draft[data.currency] = draft[data.currency] + data.value
              }
            )
          )
        } catch {
          //catch
        }
      }
    }),
    getRecipeCraftInfo: builder.query<IRecipeCraftInfo, string>({
      query: (recipeId) => ({
        url: `${basePath}/${recipeId}/craft-info`,
        method: "GET"
      }),
      providesTags: (_, __, recipeId) => [
        { type: TAGS.RECIPES, id: "CRAFT_INFO" },
        { type: TAGS.RECIPES, id: `CRAFT_INFO:${recipeId}` }
      ]
    }),
    craftRecipe: builder.mutation<IRecipeCraftResponse, string>({
      query: (recipeInstanceId) => ({
        url: `${basePath}/craft`,
        method: "POST",
        data: { recipeInstanceId }
      }),
      invalidatesTags: [
        { type: TAGS.RECIPES, id: "LIST" },
        { type: TAGS.APPARELS, id: "SET_INFO" },
        { type: TAGS.APPARELS, id: "SET_FULL_INFO" },
        { type: TAGS.APPARELS, id: "LIST" }
      ],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled

          if (data?.gold !== undefined) {
            dispatch(
              balanceEndpoints.util.updateQueryData(
                "getBalance",
                undefined,
                (draft) => {
                  draft.gold = draft.gold - data.gold
                }
              )
            )
          }
        } catch {
          //catch
        }
      }
    })
  })
})

export const {
  useGetRecipesQuery,
  useGetRecipeCraftInfoQuery,
  useLazyGetRecipeCraftInfoQuery,
  useSellRecipeMutation,
  useCraftRecipeMutation
} = recipeEndpoints
